import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useEffect, useState } from 'react';
import { getMostRecentTimestamp } from '../../timestamps';

dayjs.extend(relativeTime);

export function useLastSyncTime() {
    const [lastSyncAt, setLastSyncAt] = useState('');

    const fetchLastSyncTime = async () => {
        const timestamp = (await getMostRecentTimestamp()) ?? Date.now();
        setLastSyncAt(dayjs().to(dayjs(timestamp)));
    };

    useEffect(() => {
        fetchLastSyncTime();

        const interval = setInterval(async () => {
            fetchLastSyncTime();
        }, 10_000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return lastSyncAt;
}
